require("./brokerCryptoModalHeader.scss");
// @vendors
import React from "react";

const CryptoModalHeader = ({ title, onClose }) => (
    <div className="crypto-modal-header__container">
        <div className="crypto-modal-header__close-container">
            <button
                className="icon icon-cerrar crypto-modal-header__icon"
                onClick={onClose}
                aria-label="Close"
            />
        </div>
        {title && (
            <div className="crypto-modal-header__title-container">
                <h1 className="crypto-modal-header__title">{title}</h1>
            </div>
        )}
    </div>
);

export { CryptoModalHeader };
